import { api } from "./client";

// --- Типове ---

// Отговор от /push/vapid-public-key; publicKey: null = функцията е изключена
// на BE (липсват VAPID ключове) и целият push UI се крие.
export interface VapidPublicKeyResponse {
  publicKey: string | null;
}

// Потребител, абониран за известия на текущото устройство.
export interface PushSubscriber {
  userId: number;
  name: string;
}

// Заявка за регистрация/опресняване на устройство (PushSubscription данните).
export interface RegisterPushDeviceRequest {
  endpoint: string;
  p256dh: string;
  auth: string;
}

// Отговор от /push/devices/current: абониран ли е ТЕКУЩИЯТ потребител на това
// устройство + пълният списък абонирани (за екрана на общия акаунт).
export interface CurrentPushDeviceResponse {
  subscribed: boolean;
  subscribers: PushSubscriber[];
}

// --- API функции ---

/** GET /push/vapid-public-key — публичният VAPID ключ за pushManager.subscribe. */
export async function getVapidPublicKey(): Promise<VapidPublicKeyResponse> {
  const response = await api.get<VapidPublicKeyResponse>(
    "/push/vapid-public-key",
  );
  return response.data;
}

/** PUT /push/devices — регистрира/опреснява устройството (endpoint + ключове). */
export async function registerDevice(
  data: RegisterPushDeviceRequest,
): Promise<void> {
  await api.put("/push/devices", data);
}

/** GET /push/devices/current — състоянието на това устройство (по endpoint). */
export async function getCurrentDevice(
  endpoint: string,
): Promise<CurrentPushDeviceResponse> {
  const response = await api.get<CurrentPushDeviceResponse>(
    "/push/devices/current",
    { params: { endpoint } },
  );
  return response.data;
}

/** POST /push/devices/subscriptions — закача ТЕКУЩИЯ потребител към устройството. */
export async function subscribeSelf(endpoint: string): Promise<void> {
  await api.post("/push/devices/subscriptions", { endpoint });
}

/**
 * DELETE /push/devices/subscriptions — маха връзка: без userId — себе си;
 * с userId — подадения потребител (позволено само от нивото на общия акаунт).
 */
export async function unsubscribe(
  endpoint: string,
  userId?: number,
): Promise<void> {
  await api.delete("/push/devices/subscriptions", {
    data: userId === undefined ? { endpoint } : { endpoint, userId },
  });
}
